import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react'
import moment from "moment";
import { CallsTable, ICall } from './CallsTable';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

export interface Record {
    recordId: string;
}

const Monitoring = () => {

    const [data, setData] = useState<ICall[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showRecordsModal, setShowRecordsModal] = useState<boolean>(false);
    const [selectedCallId, setSelectedCallId] = useState<string | undefined>(undefined);
    const [records, setRecords] = useState<Record[]>([]);
    const [isFetchingRecords, setIsFetchingRecords] = useState<boolean>(false);


    const refreshData = useCallback(async () => {
        try {
            setIsLoading(true);
            const res = await axios.get('https://getlastcalls-5kg2vejuqa-uc.a.run.app');

            const calls = res.data;
            if (Array.isArray(calls)) {
                setData(calls.map(call => ({
                    id: call.sid,
                    duration: Number(call.duration),
                    from: call.from,
                    to: call.to,
                    status: call.status,
                    startedAt: moment(call.start_time).toDate()
                })));
            }
        } catch (error) {
            setData([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        refreshData()
    }, [refreshData]);

    const fetchRecords = useCallback(async (callId: string) => {
        try {
            setRecords([]);
            setIsFetchingRecords(true);
            const res = await axios.post('https://getcallrecords-5kg2vejuqa-uc.a.run.app', {
                callId: callId
            });

            const records = res.data;
            if (Array.isArray(records)) {
                setRecords(records.map(record => ({
                    recordId: record.sid
                })));
            }
        } catch (error) {
            setRecords([]);
        } finally {
            setIsFetchingRecords(false);
        }
    }, []);
    return (
        <>
            <div className='shadow-md border rounded-2xl p-6 bg-white max-w-[800px]'>
                <div className='space-y-6'>
                    <div className='font-bold text-2xl'>Últimas llamadas</div>
                    <div className='text-base'>Visualiza las últimas 500 llamadas</div>
                    <div className='flex flex-col space-y-4'>
                        <div className='self-end'>
                            <LoadingButton
                                loading={isLoading}
                                variant="outlined"
                                size="large"
                                onClick={refreshData}
                            >
                                Actualizar
                            </LoadingButton>
                        </div>
                        <CallsTable
                            data={data}
                            onViewRecords={(callId) => {
                                setShowRecordsModal(true);
                                setSelectedCallId(callId);
                                fetchRecords(callId);
                            }} />
                    </div>
                </div>
            </div>
            <Dialog
                fullWidth
                open={showRecordsModal}
                onClose={() => {}}
            >
                <DialogTitle>Grabaciones</DialogTitle>
                <DialogContent dividers>
                    {records.length === 0 && (
                        <Typography variant="subtitle1">
                            No hay grabaciones disponibles
                        </Typography>
                    )}
                    {records.length > 0 && (
                        <div className='space-y-3'>
                            {records.map(record => (
                                <audio controls preload="auto" key={record.recordId} className='w-full' src={`https://getwavcallrecord-5kg2vejuqa-uc.a.run.app?recordId=${record.recordId}`}>
                                </audio>
                            ))}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Stack spacing={2} direction='row'>
                        <Button autoFocus onClick={() => {
                            setRecords([]);
                            setIsFetchingRecords(false);
                            setSelectedCallId(undefined);
                            setShowRecordsModal(false);
                        }}>
                            Salir
                        </Button>
                        <LoadingButton loading={isFetchingRecords} onClick={() => {
                            if (selectedCallId !== undefined) fetchRecords(selectedCallId);
                        }}>Actualizar</LoadingButton>
                    </Stack>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { Monitoring }